import * as Yup from 'yup'
import { REQUIRED_FIELDS, GENDER_OPTIONS, DENTAL_CONDITIONS } from './constants'

const REQUIRED = 'This field is required.'

// `options` carries the catalogs served by the public show endpoint; it falls
// back to the bundled constants for the staff read-only view, which has none.
export const buildHealthHistorySchema = (setting = {}, options = {}) => {
  const genders = options.genders || GENDER_OPTIONS
  const dentalConditions = options.dental_conditions || DENTAL_CONDITIONS
  const shape = {}

  // Presence-required text/date fields.
  REQUIRED_FIELDS.forEach(field => {
    if (field === 'gender') return
    shape[field] = Yup.string().trim().required(REQUIRED)
  })

  shape.gender = Yup.string()
    .oneOf(genders.map(o => o.value), REQUIRED)
    .required(REQUIRED)

  // Required boolean radios (submitted as 'true'/'false' strings).
  ;['premedication', 'latex_allergic', 'smoked'].forEach(field => {
    shape[field] = Yup.string().oneOf(['true', 'false'], REQUIRED).required(REQUIRED)
  })

  shape.dental_conditions = Yup.array().of(Yup.string()).default([])

  // Each condition's describe column is required when its box is checked.
  dentalConditions.forEach(({ value }) => {
    shape[value] = Yup.string().when('dental_conditions', {
      is: conditions => Array.isArray(conditions) && conditions.includes(value),
      then: s => s.trim().required(REQUIRED),
      otherwise: s => s.nullable(),
    })
  })

  if (setting.terms_enabled) {
    shape.accepts_conditions = Yup.boolean().oneOf([true], REQUIRED).required(REQUIRED)
  }

  if (setting.signature_enabled) {
    shape.signature = Yup.string().trim().required(REQUIRED)
  }

  return Yup.object().shape(shape, [['dental_conditions', 'dental_conditions']])
}
